import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import SignatureBlock from 'PDF/Signatures';
import { baseStyles } from 'PDF/TemplateEngine/styles';

function SignaturesSection({ section, data }) {
  const config = section?.config || {};

  return (
    <View wrap={false}>
      {section?.title ? <Text style={baseStyles.sectionTitle}>{section.title}</Text> : null}
      <SignatureBlock
        specialistName={config.showSpecialist ? data?.specialist_name : null}
        specialistSignature={config.showSpecialist ? data?.specialist_signature : null}
        specialistEspecialidad={config.showSpecialist ? data?.specialist_especialidad : null}
        specialistCargo={config.showSpecialist ? data?.specialist_cargo : null}
        specialistOtros={config.showSpecialist ? data?.specialist_otros : null}
        recepcionistName={config.showReceptionist ? data?.recepcionist_name : null}
        recepcionistSignature={config.showReceptionist ? data?.recepcionist_signature : null}
        recepcionistCharge={config.showReceptionist ? data?.recepcionist_charge : null}
      />
    </View>
  );
}

export default SignaturesSection;
